import globalActions from "../api/GlobalActions.js"
import globalMutations from "../api/GlobalMutations.js"
import globalGetters from "../api/GlobalGetters.js"

export const state = () => ({
  isStale: true,
  latest_fetch: "",
  type: "files",
  pageLayout: "StructureTable",
  canEdit: false,
  canView: false,
  effectedByYear: false,
  yearFields: [],
  aliasField: "filename",
  relations: [],
  all: {},
  reference: {},
  active: false,
  page: 1,
  searchFields: ["filename"],
  modelLabels: {
    single: "File",
    plural: "Files"
  },
  pageCount: 0,
  pagination: {
    groupBy: [],
    groupDesc: [],
    multiSort: false,
    mustSort: false,
    itemsPerPage: 150,
    sort: true,
    sortBy: "filename",
    page: 1,
    sortDesc: []
  },
  print_path: "",
  search: null,
  total: 0,
  print: false,
  export: false,
  bound: {},
  filter: {},
  stub: {},
  include: [],
  headers: {},
  notifications: {}
})

// Mutations ==================

export const mutations = {
  ...globalMutations
}

// Actions ====================

export const actions = {
  ...globalActions
}

// Getters ====================

export const getters = {
  ...globalGetters
}
